import { SELECT_ALL_OPTION, SELECT_SELECTION } from '@/constants/select';
import { Checkbox, FormControlLabel, SxProps, Theme, formControlLabelClasses } from '@mui/material';
import { useMemo } from 'react';
import ListOption from './ListOption';

interface IProps {
  total: number;
  indeterminate: boolean;
  checked: boolean;
  label: string;
  onChange: () => void;
  sx?: SxProps<Theme>;
  partialSelection?: boolean;
  disabled?: boolean;
}

const SelectAllOption = ({
  total,
  indeterminate,
  checked,
  label,
  onChange,
  sx = {},
  partialSelection = false,
  disabled,
}: IProps) => {
  const { value, label: displayLabel } = useMemo(
    () => (partialSelection ? SELECT_SELECTION : SELECT_ALL_OPTION),
    [partialSelection],
  );

  return (
    <ListOption selected={checked} sx={sx}>
      <FormControlLabel
        control={<Checkbox checked={checked} indeterminate={indeterminate} />}
        value={value}
        onChange={onChange}
        disabled={disabled}
        label={
          <div className='flex justify-between w-full'>
            <span>{displayLabel}</span>
            <span className='text-[#84818A] text-[12px] font-medium'>{`${total} ${label}${
              total % 10 == 1 ? '' : 's'
            }`}</span>
          </div>
        }
        sx={{
          margin: 0,
          width: '100%',
          [`& .${formControlLabelClasses.label}`]: {
            width: '100%',
          },
          padding: '6px 16px 6px 12px',
        }}
      />
    </ListOption>
  );
};

export default SelectAllOption;
